import { type SingleDomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const navigationViewAccessControl: SingleDomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.storefront],
  permissions: [Permission.StoreConfigsView, Permission.StorefrontNavigationView],
}

export const navigationModifyAccessControl: SingleDomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.storefront],
  permissions: [Permission.StoreConfigsModify],
}

export const departmentNavigationAccessControl: SingleDomainAccessControlConfig = {
  permissions: [Permission.DepartmentsView],
  warehouseFeatureToggles: [FeatureToggle.retailerCollectionsV2],
}

export const marketplaceOnlyDepartmentNavigationAccessControl: SingleDomainAccessControlConfig = {
  permissions: [Permission.DepartmentsView],
  warehouseFeatureToggles: [
    FeatureToggle.retailerCollectionsV2,
    FeatureToggle.RetailerCollectionsV2Ux,
  ],
  notWarehouseFeatureToggles: [FeatureToggle.storefront],
}

export const departmentNavigationAdminAccessControl: SingleDomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.retailerCollectionsV2],
  notWarehouseFeatureToggles: [FeatureToggle.storefront, FeatureToggle.RetailerCollectionsV2Ux],
  permissions: [Permission.AdminPanel],
}

export const navigationOpenContentPageFlyoutAccessControl: SingleDomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.openContentPageFlyoutNavigationAction],
}
